import {
  createConsoleLogger as createConfigCatLogger,
  getClient as getConfigCatClient,
  IConfigCatClient,
  LogLevel,
  PollingMode,
  User as ConfigCatUser,
} from 'configcat-js';
import { emit, getEnvironmentName, getTenantName } from '@prosaas/psw-utils';
import type { IConfigCatRequest, IKeyGroupByCategory, ISdkKeys } from '../interfaces/configCat.interfaces';

const environmentNames: Record<keyof ISdkKeys, string> = {
  testing: 'testing',
  testingKenya: 'testingKenya',
  stagingKenya: 'stagingKenya',
  staging: 'staging',
  productionKenya: 'productionKenya',
};

const isEnvironmentName = (environmentName: string): environmentName is keyof ISdkKeys =>
  environmentNames[environmentName] !== undefined;

export const getConfigCatKey = (
  sdkKeyGroup: IKeyGroupByCategory,
  type: keyof IKeyGroupByCategory,
  environmentName: string,
) => {
  if (isEnvironmentName(environmentName)) {
    return sdkKeyGroup?.[type]?.[environmentName];
  }

  throw Error(`Unknown environment name: ${environmentName}`);
};

const isProduction = getEnvironmentName() === 'productionKenya';
const logger = createConfigCatLogger(isProduction ? LogLevel.Off : LogLevel.Info);

export const configCatClientFactory = (configCatSDKKey: string): IConfigCatClient =>
  getConfigCatClient(configCatSDKKey, PollingMode.AutoPoll, {
    logger,
  });

export const configCatHandlerFactory = (defaultsClient: IConfigCatClient, channel: string) =>
  function configCatHandler({ requestId, payload }: IConfigCatRequest): void {
    if (!requestId) {
      throw Error('Missing requestId');
    }
    if (!payload) {
      throw Error('Missing payload');
    }
    const userCC = payload.userId
      ? new ConfigCatUser(payload.userId, undefined, undefined, {
          tenant: getTenantName(),
        })
      : new ConfigCatUser(undefined, undefined, undefined, { tenant: getTenantName() });

    defaultsClient.getValueAsync(payload.flagName, payload.defaultValue, userCC).then((response) => {
      emit(`${channel}_${requestId}`, response);
    });
  };
